export default "/kiban/_next/static/images/top_blue-fe115896cdd777385c0055cc3088c9d0.png";